import { useIntl } from 'react-intl';
import { AsideMenuItem } from './AsideMenuItem';
import { useSelector } from 'react-redux';
import { authUserSelector } from '../../../../app/modules/auth';

export function AsideMenuTacho() {
  const intl = useIntl();
  const authUser = useSelector(authUserSelector);
  const isTachoUser = !!authUser?.groups?.find(
    (aGroup) => aGroup.name === 'Tacho'
  );

  return isTachoUser ? (
    <>
      <h5 className="menu-title text-light pb-4 mb-0 mt-2 ms-6">
        {intl.formatMessage({ id: 'menu.tacho' })}
      </h5>
      <AsideMenuItem
        to={`/tacho-orders`}
        title={intl.formatMessage({ id: 'menu.tachoOrders' })}
        fontIcon="fa-box"
      />
      <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
